import { ClipboardList, Target, Flame } from "lucide-react";

const steps = [
  {
    n: "01",
    icon: ClipboardList,
    title: "Evaluación inicial",
    text: "Analizamos tu cuerpo, tus hábitos, tu trabajo y tu historia. Sin juicios. Aquí entendemos POR QUÉ estás donde estás.",
  },
  {
    n: "02",
    icon: Target,
    title: "Plan personalizado",
    text: "Diseño tu nutrición y tu entrenamiento a medida: comidas reales, gimnasio o casa, tiempo del que dispones. Nada de plantillas genéricas.",
  },
  {
    n: "03",
    icon: Flame,
    title: "Acompañamiento diario",
    text: "Estoy contigo. Ajustamos cada semana, resolvemos imprevistos y celebramos cada victoria hasta que el CAMBIO es tuyo para siempre.",
  },
];

export const ComoFunciona = () => {
  return (
    <section
      id="metodo"
      data-testid="section-metodo"
      className="relative bg-[#0F0F0F] py-24 sm:py-32 border-t border-zinc-900"
    >
      <div className="w-full max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-3xl">
          <p className="text-xs sm:text-sm text-[#FF5A1F] uppercase tracking-[0.25em] font-bold mb-6">
            02 — Cómo funciona
          </p>
          <h2
            data-testid="metodo-heading"
            className="font-display font-black uppercase text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tighter"
          >
            Tres pasos. <br />
            <span className="text-[#FF5A1F]">Cero excusas.</span>
          </h2>
          <p className="mt-6 text-lg text-zinc-400 max-w-2xl leading-relaxed">
            Un proceso claro y honesto. Lo mismo da que entrenes desde casa o en
            el gym de la esquina, lo mismo da si viajas o tienes turnos. Lo
            adaptamos.
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-6 lg:gap-8">
          {steps.map((s) => {
            const Icon = s.icon;
            return (
              <div
                key={s.n}
                data-testid={`step-card-${s.n}`}
                className="relative bg-zinc-950 border border-zinc-800 p-8 lg:p-10 hover:border-[#FF5A1F]/60 transition-colors group overflow-hidden"
              >
                <span
                  className="absolute -top-6 -right-2 font-display font-black text-[140px] leading-none text-zinc-900 select-none pointer-events-none group-hover:text-[#FF5A1F]/10 transition-colors"
                  aria-hidden
                >
                  {s.n}
                </span>
                <Icon size={32} className="text-[#FF5A1F] relative" />
                <h3 className="relative font-display uppercase font-black text-2xl sm:text-3xl text-white mt-6 tracking-tight">
                  {s.title}
                </h3>
                <p className="relative mt-4 text-zinc-400 leading-relaxed">
                  {s.text}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
